import React, { useEffect, useRef } from 'react';
import { useGetAdminDashboardQuery } from '../../../store/api/adminApi';
import PageLoader from '../../../components/PageLoader';
import BarChart from '../../../components/charts/BarChart';
import PieChart from '../../../components/charts/PieChart';
import total_chats from '../../../assets/images/total_chats.png';
import closed_chat from '../../../assets/images/closed_chat.png';
import user_stats from '../../../assets/images/user-stats.png';
import products from '../../../assets/images/products.png';
import articles from '../../../assets/images/articles.png';
import exhibitions from '../../../assets/images/exhibitions.png';
import subscriptions from '../../../assets/images/subscriptions.png';
import expired_subscriptions from '../../../assets/images/expired_subscriptions.png';
import subscription_purchased from '../../../assets/images/subscription_purchased.png';
import customers_registered from '../../../assets/images/customers_registered.png';
import customers_stats from '../../../assets/images/customers_stats.png';

const AdminDashboard: React.FC = () => {
  const { data, isLoading, error } = useGetAdminDashboardQuery(undefined);

  if (isLoading) {
    return <PageLoader />;
  }

  if (error) {
    return (
      <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
        <div className="alert alert-danger m-5">Error loading dashboard</div>
      </div>
    );
  }

  const dashboardData = data?.data || {};
  const chartData = dashboardData.chart_data || {};
  const monthLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  return (
    <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
      <div className="d-flex flex-column flex-column-fluid">
        <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
          <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
            <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
              <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Dashboard</h1>
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <li className="breadcrumb-item text-muted">
                  <a href="#" className="text-muted text-hover-primary">Home</a>
                </li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item text-muted">Dashboards</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div id="kt_app_content" className="app-content flex-column-fluid">
          <div id="kt_app_content_container" className="app-container container-fluid">
            <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
              <div className="col-md-3 mb-md-5 mb-xl-10">
                <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10 bg-base">
                  <div className="card-header pt-5">
                    <div className="card-title d-flex flex-column">
                      <span className="fs-2hx fw-bold text-white me-2 lh-1 ls-n2">{dashboardData.total_items || 0}</span>
                      <span className="text-white opacity-75 pt-1 fw-semibold fs-4">Total Products</span>
                    </div>
                  </div>
                  <div className="card-body d-flex align-items-end pt-0">
                    <img src={products} className="w-50px" alt="" />
                  </div>
                </div>
              </div>
              
              <div className="col-md-3 mb-md-5 mb-xl-10">
                <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10 bg-base">
                  <div className="card-header pt-5">
                    <div className="card-title d-flex flex-column text-dark">
                      <span className="fs-2hx fw-bold text-white me-2 lh-1 ls-n2">{dashboardData.total_users || 0}</span>
                      <span className="text-white opacity-75 pt-1 fw-semibold fs-4">Total Customers</span>
                    </div>
                  </div>
                  <div className="card-body d-flex align-items-end pt-0">
                    <img src={user_stats} className="w-50px" alt="" />
                  </div>
                </div>
              </div>
              
              <div className="col-md-3 mb-md-5 mb-xl-10">
                <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10 bg-base">
                  <div className="card-header pt-5">
                    <div className="card-title d-flex flex-column">
                      <span className="fs-2hx fw-bold text-white me-2 lh-1 ls-n2">{dashboardData.total_articles || 0}</span>
                      <span className="text-white opacity-75 pt-1 fw-semibold fs-4">Total Articles</span>
                    </div>
                  </div>
                  <div className="card-body d-flex align-items-end pt-0">
                    <img src={articles} className="w-50px" alt="" />
                  </div>
                </div>
              </div>
              
              <div className="col-md-3 mb-md-5 mb-xl-10">
                <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10 bg-base">
                  <div className="card-header pt-5">
                    <div className="card-title d-flex flex-column">
                      <span className="fs-2hx fw-bold text-white me-2 lh-1 ls-n2">{dashboardData.total_activities || 0}</span>
                      <span className="text-white opacity-75 pt-1 fw-semibold fs-4">Total Activities</span>
                    </div>
                  </div>
                  <div className="card-body d-flex align-items-end pt-0">
                    <img src={user_stats} className="w-50px" alt="icon" />
                  </div>
                </div>
              </div>
              
              <div className="col-md-3 mb-md-5 mb-xl-10">
                <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10 bg-base">
                  <div className="card-header pt-5">
                    <div className="card-title d-flex flex-column">
                      <span className="fs-2hx fw-bold text-white me-2 lh-1 ls-n2">{dashboardData.total_exhibitions || 0}</span>
                      <span className="text-white opacity-75 pt-1 fw-semibold fs-4">Total Exhibitions</span>
                    </div>
                  </div>
                  <div className="card-body d-flex align-items-end pt-0">
                    <img src={products} className="w-50px" alt="icon" />
                  </div>
                </div>
              </div>
              
              {dashboardData.tickets && (
                <>
                  <div className="col-md-3 mb-md-5 mb-xl-10">
                    <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10 bg-base">
                      <div className="card-header pt-5">
                        <div className="card-title d-flex flex-column">
                          <span className="fs-2hx fw-bold text-white me-2 lh-1 ls-n2">{dashboardData.tickets.total || 0}</span>
                          <span className="text-white opacity-75 pt-1 fw-semibold fs-4">Total Tickets</span>
                        </div>
                      </div>
                      <div className="card-body d-flex align-items-end pt-0">
                        <img src={total_chats} className="w-50px" alt="icon" />
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-3 mb-md-5 mb-xl-10">
                    <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10 bg-base">
                      <div className="card-header pt-5">
                        <div className="card-title d-flex flex-column">
                          <span className="fs-2hx fw-bold text-white me-2 lh-1 ls-n2">{dashboardData.tickets.unreplied || 0}</span>
                          <span className="text-white opacity-75 pt-1 fw-semibold fs-4">Unresponded Tickets</span>
                        </div>
                      </div>
                      <div className="card-body d-flex align-items-end pt-0">
                        <img src={closed_chat} className="w-50px" alt="icon" />
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-3 mb-md-5 mb-xl-10">
                    <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10 bg-base">
                      <div className="card-header pt-5">
                        <div className="card-title d-flex flex-column">
                          <span className="fs-2hx fw-bold text-white me-2 lh-1 ls-n2">{dashboardData.tickets.opened || 0}</span>
                          <span className="text-white opacity-75 pt-1 fw-semibold fs-4">Opened Tickets</span>
                        </div>
                      </div>
                      <div className="card-body d-flex align-items-end pt-0">
                        <img src={closed_chat} className="w-50px" alt="icon" />
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-3 mb-md-5 mb-xl-10">
                    <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10 bg-base">
                      <div className="card-header pt-5">
                        <div className="card-title d-flex flex-column">
                          <span className="fs-2hx fw-bold text-white me-2 lh-1 ls-n2">{dashboardData.tickets.closed || 0}</span>
                          <span className="text-white opacity-75 pt-1 fw-semibold fs-4">Closed Tickets</span>
                        </div>
                      </div>
                      <div className="card-body d-flex align-items-end pt-0">
                        <img src={closed_chat} className="w-50px" alt="icon" />
                      </div>
                    </div>
                  </div>
                </>
              )}
              
              <div className="col-md-3 mb-md-5 mb-xl-10">
                <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10 bg-base">
                  <div className="card-header pt-5">
                    <div className="card-title d-flex flex-column">
                      <span className="fs-2hx fw-bold text-white me-2 lh-1 ls-n2">{(dashboardData.active_subscriptions || 0) + (dashboardData.expired_subscriptions || 0)}</span>
                      <span className="text-white opacity-75 pt-1 fw-semibold fs-4">Total Subscriptions</span>
                    </div>
                  </div>
                  <div className="card-body d-flex align-items-end pt-0">
                    <img src={user_stats} className="w-50px" alt="icon" />
                  </div>
                </div>
              </div>
              
              <div className="col-md-3 mb-md-5 mb-xl-10">
                <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10 bg-base">
                  <div className="card-header pt-5">
                    <div className="card-title d-flex flex-column">
                      <span className="fs-2hx fw-bold text-white me-2 lh-1 ls-n2">{dashboardData.active_subscriptions || 0}</span>
                      <span className="text-white opacity-75 pt-1 fw-semibold fs-4">Active Subscriptions</span>
                    </div>
                  </div>
                  <div className="card-body d-flex align-items-end pt-0">
                    <img src={user_stats} className="w-50px" alt="icon" />
                  </div>
                </div>
              </div>
              
              <div className="col-md-3 mb-md-5 mb-xl-10">
                <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10 bg-base">
                  <div className="card-header pt-5">
                    <div className="card-title d-flex flex-column">
                      <span className="fs-2hx fw-bold text-white me-2 lh-1 ls-n2">{dashboardData.expired_subscriptions || 0}</span>
                      <span className="text-white opacity-75 pt-1 fw-semibold fs-4">Expired Subscriptions</span>
                    </div>
                  </div>
                  <div className="card-body d-flex align-items-end pt-0">
                    <img src={user_stats} className="w-50px" alt="icon" />
                  </div>
                </div>
              </div>

            </div>

            <div className="row g-5 g-xl-10 mb-5 mb-xl-10">

              <div className="col-md-6 mb-md-5 mb-xl-10">
                <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10 bg-white border">
                  <div className="card-header pt-5">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold text-dark">Customers Status</span>
                      <span className="text-gray-400 mt-1 fw-semibold fs-6">Subscribed vs Unsubscribed</span>
                    </h3>
                  </div>
                  <div className="card-body d-flex align-items-center justify-content-center pt-0 pb-5" style={{ minHeight: '280px', position: 'relative' }}>
                    {dashboardData.subscribed_users !== undefined && dashboardData.un_subscribed_users !== undefined ? (
                      <div style={{ width: '100%', maxWidth: '250px', height: '250px' }}>
                        <PieChart
                          labels={['Subscribed Customers', 'UnSubscribed Customers']}
                          data={[dashboardData.subscribed_users || 0, dashboardData.un_subscribed_users || 0]}
                          backgroundColor={['rgba(106, 206, 114, 0.8)', 'rgba(67, 67, 67, 0.8)']}
                          options={{
                            responsive: true,
                            maintainAspectRatio: true,
                            plugins: {
                              legend: {
                                display: true,
                                position: 'bottom' as const,
                                labels: {
                                  padding: 15,
                                  font: {
                                    size: 12,
                                  },
                                  usePointStyle: true,
                                },
                              },
                              tooltip: {
                                enabled: true,
                              },
                            },
                          }}
                        />
                      </div>
                    ) : (
                      <div className="text-muted d-flex align-items-center justify-content-center" style={{ minHeight: '200px' }}>No data available</div>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="col-md-6">
                <div className="card card-flush overflow-hidden">
                  <div className="card-header pt-5">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold text-dark">Subscription Purchased Stats</span>
                      <span className="text-gray-400 mt-1 fw-semibold fs-6">Customers purchase subscription per month</span>
                    </h3>
                  </div>
                  <div className="card-body d-flex align-items-end p-0" style={{ minHeight: '300px' }}>
                    {chartData.month_subscriptions ? (
                      <BarChart
                        labels={monthLabels}
                        datasets={[{
                          label: 'Subscription Purchased',
                          data: chartData.month_subscriptions || [],
                          backgroundColor: 'rgba(79, 211, 136, 0.6)',
                          borderColor: 'rgba(79, 211, 136, 1)',
                        }]}
                      />
                    ) : (
                      <div className="text-muted p-5">No data available</div>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="col-md-6">
                <div className="card card-flush overflow-hidden">
                  <div className="card-header pt-5">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold text-dark">Customers Stats</span>
                      <span className="text-gray-400 mt-1 fw-semibold fs-6">Customers registered per month</span>
                    </h3>
                  </div>
                  <div className="card-body d-flex align-items-end p-0" style={{ minHeight: '300px' }}>
                    {chartData.month_users ? (
                      <BarChart
                        labels={monthLabels}
                        datasets={[{
                          label: 'Customers Registered',
                          data: chartData.month_users || [],
                          backgroundColor: 'rgba(79, 211, 136, 0.6)',
                          borderColor: 'rgba(79, 211, 136, 1)',
                        }]}
                      />
                    ) : (
                      <div className="text-muted p-5">No data available</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
